module.exports = __webpack_public_path__ + "static/media/iq.a1520bca.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/iq.svg
// module id = 849
// module chunks = 0